<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.75 7.75L10 12.5L5.25 7.75" stroke="currentColor" stroke-width="0.95" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
